/* GENERATED — edit lib/, not this file.
 *
 * Built by scripts/build-theme-assets.mjs from:
 *   lib/synonyms.mjs
 *   lib/search.mjs
 *   theme/src/learn-search-ui.js
 *
 * The scorer below is the SAME code node --test runs against, concatenated
 * and wrapped in an IIFE because the theme has no bundler. Editing it here
 * will be overwritten and will fail `npm test` (the staleness check).
 */
(function () {
  "use strict";

  /* ---------- generated from lib/ ---------- */
  // Query-expansion synonyms — ARCHITECTURE.md §9. Deliberately hand-written and
  // small: these are the terms where Thomas's customers and Thomas's product
  // names genuinely differ ("vinyl" is what customers type; "sticker paper" is
  // what the products are called), not a general thesaurus.
  //
  // Expansion is one-directional per entry but the map is applied BOTH ways at
  // build time (see expand()), so "cricut" finds "cutting machine" content and
  // "cutting machine" finds "cricut" content without listing every pair twice.
  const PAIRS = [
    ["vinyl", "sticker paper"],
    ["cricut", "cutting machine"],
    ["silhouette", "cutting machine"],
    ["duties", "tariffs"],
    ["duty", "tariffs"],
    ["customs", "tariffs"],
    ["laminate", "laminating"],
    ["laminator", "laminating"],
    ["holo", "holographic"],
    ["bookmark", "magnetic bookmark"],
    ["qr", "qr code"],
    ["print", "printing"],
    ["postage", "shipping"],
    ["ddp", "delivered duty paid"],
  ];

  // term → Set of terms it also matches (including itself).
  const SYNONYMS = (() => {
    const m = new Map();
    const add = (a, b) => {
      if (!m.has(a)) m.set(a, new Set([a]));
      m.get(a).add(b);
    };
    for (const [a, b] of PAIRS) { add(a, b); add(b, a); }
    return m;
  })();

  // Returns every term a query token should also look for. A multi-word synonym
  // ("sticker paper") is returned whole — the scorer matches it as a phrase
  // against the joined field text, which is why fields keep their spaces.
  function expand(token) {
    const set = SYNONYMS.get(token);
    return set ? [...set] : [token];
  }

  // Learn search scorer — ARCHITECTURE.md §9. Pure functions over an in-memory
  // index; no I/O, no dependencies, so it runs identically in the browser (loaded
  // from the CDN'd learn-index.json) and in `node --test`.
  //
  // Design notes worth keeping:
  // - Field weights are title > tags > description > transcript. A transcript is
  //   long, so an incidental mention there must never outrank a title match.
  // - Typo tolerance is two measures, both only reached when a token doesn't match
  //   exactly, so the common path costs nothing:
  //     Dice bigram similarity — cheap, length-normalised, strong on omission and
  //       substitution ("holograpic"→"holographic" 0.84, "laminting"→"laminating"
  //       0.82, "tarrifs"→"tariffs" 0.83).
  //     Damerau-Levenshtein — run only for tokens ≤ 8 characters, because Dice is
  //       structurally weak on adjacent transposition: swapping two characters
  //       destroys three bigrams at once, so "bookmrak"→"bookmark" scores just 0.57
  //       and would be missed. DL counts that as the single edit it actually is.
  //   The two are combined with max(), so a word only has to look close by ONE of
  //   them. The ≤ 8 cap is why this isn't just "use DL for everything": DL is
  //   O(a×b) per pair against every field token of every item, and the transposition
  //   problem is concentrated in short words — a long word with a transposition
  //   still has enough surviving bigrams for Dice to catch it.
  // - Fuzzy matches are scored BELOW exact ones (multiplied by the similarity),
  //   so a real match always beats a near-miss.

  const FIELD_WEIGHTS = { title: 10, tags: 6, description: 3, transcript: 1 };

  // A fuzzy match needs to be at least this similar to count at all. 0.7 keeps
  // "holograpic"→"holographic" (0.84) and rejects "holiday"→"holographic" (0.25).
  const FUZZY_THRESHOLD = 0.7;

  // Damerau-Levenshtein only runs at or below this length. See the note above.
  const DL_MAX_LEN = 8;

  function normalise(s) {
    return String(s || "").toLowerCase().replace(/[^a-z0-9\s-]/g, " ").replace(/\s+/g, " ").trim();
  }

  function tokenise(s) {
    const n = normalise(s);
    return n ? n.split(" ").filter(Boolean) : [];
  }

  // Dice coefficient over character bigrams: 2·|shared| / (|a| + |b|).
  function bigramSimilarity(a, b) {
    if (a === b) return 1;
    if (a.length < 2 || b.length < 2) return 0;
    const bigrams = (s) => {
      const out = new Map();
      for (let i = 0; i < s.length - 1; i++) {
        const g = s.slice(i, i + 2);
        out.set(g, (out.get(g) || 0) + 1);
      }
      return out;
    };
    const ga = bigrams(a), gb = bigrams(b);
    let shared = 0, total = 0;
    for (const n of ga.values()) total += n;
    for (const [g, n] of gb) {
      total += n;
      if (ga.has(g)) shared += Math.min(ga.get(g), n);
    }
    return total ? (2 * shared) / total : 0;
  }

  // Optimal string alignment distance — Damerau-Levenshtein restricted so a
  // substring is not edited twice. That restriction is the right one here: it
  // handles the single adjacent transposition people actually type, and it is the
  // cheaper, simpler recurrence. Returns an edit count.
  function damerauLevenshtein(a, b) {
    if (a === b) return 0;
    const al = a.length, bl = b.length;
    if (!al) return bl;
    if (!bl) return al;
    // Full matrix rather than two rolling rows: the transposition term needs row
    // i-2, so rolling rows would have to keep three anyway — no real saving at
    // these lengths, and this stays readable.
    const d = Array.from({ length: al + 1 }, (_, i) => {
      const row = new Array(bl + 1).fill(0);
      row[0] = i;
      return row;
    });
    for (let j = 0; j <= bl; j++) d[0][j] = j;
    for (let i = 1; i <= al; i++) {
      for (let j = 1; j <= bl; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(
          d[i - 1][j] + 1,        // deletion
          d[i][j - 1] + 1,        // insertion
          d[i - 1][j - 1] + cost, // substitution
        );
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);   // transposition
        }
      }
    }
    return d[al][bl];
  }

  // DL expressed on the same 0..1 scale as bigramSimilarity, so the two are
  // directly comparable and can share one threshold. Gated on DL_MAX_LEN: longer
  // pairs return 0 here and rely on Dice, which handles them well.
  function editSimilarity(a, b) {
    if (a === b) return 1;
    if (a.length > DL_MAX_LEN || b.length > DL_MAX_LEN) return 0;
    const dist = damerauLevenshtein(a, b);
    const longest = Math.max(a.length, b.length);
    return longest ? 1 - dist / longest : 0;
  }

  // The one similarity the scorer asks for. A word only needs to look close by
  // EITHER measure — they fail on different typo shapes, so max() is the point.
  function similarity(a, b) {
    return Math.max(bigramSimilarity(a, b), editSimilarity(a, b));
  }

  // Best score for one query token against one field's text.
  // Returns 0..1 — 1 for an exact word/phrase hit, similarity for a fuzzy hit.
  function tokenScoreInField(token, fieldText, fieldTokens) {
    for (const variant of expand(token)) {
      // Multi-word synonym → phrase test against the whole field.
      if (variant.includes(" ")) {
        if (fieldText.includes(variant)) return 1;
        continue;
      }
      if (fieldTokens.has(variant)) return 1;
    }
    // Prefix match ("holog" while typing) — full credit, this is what makes
    // suggestions-as-you-type feel right.
    for (const ft of fieldTokens) if (ft.length > token.length && ft.startsWith(token)) return 1;
    // Fuzzy fallback, best single word in the field — bigram OR edit distance.
    let best = 0;
    for (const ft of fieldTokens) {
      const sim = similarity(token, ft);
      if (sim > best) best = sim;
    }
    return best >= FUZZY_THRESHOLD ? best : 0;
  }

  // Precompute the per-field token sets once per item — the scorer is called
  // once per item per query, so tokenising inside it would be O(items × tokens).
  function fieldsOf(item) {
    const mk = (v) => {
      const text = normalise(Array.isArray(v) ? v.join(" ") : v);
      return { text, tokens: new Set(text ? text.split(" ") : []) };
    };
    return {
      title: mk(item.title),
      tags: mk(item.tags),
      description: mk(item.description),
      transcript: mk(item.transcript_excerpt || item.transcript),
    };
  }

  // Attach the precomputed field tokens to an item, once. Without this, scoring
  // re-tokenises every field of every item on every keystroke — O(items × fields)
  // string work per character typed. Callers that search the same array repeatedly
  // (i.e. all of them: the storefront holds one index for the page's lifetime)
  // should map their items through this at load time.
  function prepare(item) {
    if (!item._f) item._f = fieldsOf(item);
    return item;
  }

  function scoreItem(item, queryTokens, prepared) {
    const f = prepared || item._f || fieldsOf(item);
    let score = 0;
    for (const token of queryTokens) {
      for (const [field, weight] of Object.entries(FIELD_WEIGHTS)) {
        const s = tokenScoreInField(token, f[field].text, f[field].tokens);
        if (s > 0) score += s * weight;
      }
    }
    return score;
  }

  function matchesFilters(item, filters) {
    if (!filters) return true;
    if (filters.type && item.type !== filters.type) return false;
    if (filters.topic && item.topic !== filters.topic) return false;
    if (filters.difficulty && item.difficulty !== filters.difficulty) return false;
    if (filters.since && !(String(item.published_at || "") >= filters.since)) return false;
    if (filters.until && !(String(item.published_at || "") < filters.until)) return false;
    return true;
  }

  const SORTS = {
    relevance: (a, b) => b._score - a._score || String(b.published_at || "").localeCompare(String(a.published_at || "")),
    newest: (a, b) => String(b.published_at || "").localeCompare(String(a.published_at || "")),
    oldest: (a, b) => String(a.published_at || "").localeCompare(String(b.published_at || "")),
    most_viewed: (a, b) => ((b.stats && b.stats.views_all) || 0) - ((a.stats && a.stats.views_all) || 0),
    most_liked: (a, b) => ((b.stats && b.stats.likes) || 0) - ((a.stats && a.stats.likes) || 0),
  };

  // The one entry point the storefront calls.
  //   search(index, "holograpic vinyl", { filters: {type:"guide"}, sort:"relevance", limit:20 })
  // An empty query is a valid browse request: every item that passes the filters,
  // in the requested sort (defaulting to newest, since relevance is meaningless
  // with nothing to be relevant to).
  function search(index, query, opts = {}) {
    const items = Array.isArray(index) ? index : (index && index.items) || [];
    const tokens = tokenise(query);
    const sortKey = opts.sort || (tokens.length ? "relevance" : "newest");
    const sorter = SORTS[sortKey] || SORTS.relevance;

    const out = [];
    for (const item of items) {
      if (!matchesFilters(item, opts.filters)) continue;
      const score = tokens.length ? scoreItem(item, tokens) : 0;
      if (tokens.length && score <= 0) continue;
      out.push({ ...item, _score: score });
    }
    out.sort(sorter);
    return typeof opts.limit === "number" ? out.slice(0, opts.limit) : out;
  }

  const _internal = { fieldsOf, tokenScoreInField, matchesFilters, SORTS };

  // UI half of theme/assets/learn-search.js — the DOM wiring, markup and events.
  // A BODY FRAGMENT, not a standalone script: scripts/build-theme-assets.mjs
  // concatenates it after the generated scorer and supplies the IIFE wrapper, so
  // the scorer functions (search, prepare, similarity, tokenise) are in scope here
  // without an import. Edit this file for anything UI; edit lib/search.mjs for
  // anything scoring. Never edit the generated output.
  /* ---------- UI (this file is the source; the scorer above is generated) ---------- */

  var SUGGEST_LIMIT = 6;
  var RESULTS_LIMIT = 50;
  var TYPE_LABELS = { article: "Article", guide: "Guide", tutorial: "Tutorial", video: "Video", trade_update: "Trade update" };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function fmtDate(iso) {
    if (!iso) return "";
    var d = new Date(iso);
    if (isNaN(d)) return "";
    // Europe/London — the store's timezone, same rule as Operations.
    return d.toLocaleDateString("en-GB", { timeZone: "Europe/London", day: "numeric", month: "long", year: "numeric" });
  }

  // §4 ruling, 17 Aug: updated_at is unknown for most existing articles. Show
  // "Updated" ONLY when it is genuinely set, otherwise "Published" — never
  // silently present a publish date as a revision date.
  function dateLine(item) {
    if (item.updated_at) return "Updated " + fmtDate(item.updated_at);
    return item.published_at ? "Published " + fmtDate(item.published_at) : "";
  }

  function metaLine(item) {
    var bits = [];
    if (item.type) bits.push(TYPE_LABELS[item.type] || item.type);
    if (item.difficulty) bits.push(item.difficulty);
    if (item.read_minutes) bits.push(item.read_minutes + " min read");
    else if (item.watch_seconds) bits.push(Math.round(item.watch_seconds / 60) + " min watch");
    var d = dateLine(item);
    if (d) bits.push(d);
    return bits.join(" · ");
  }

  function resultHtml(item) {
    return '<a class="learn-result" href="' + esc(item.url) + '">' +
      '<span class="learn-result-type" data-type="' + esc(item.type) + '">' + esc(TYPE_LABELS[item.type] || item.type) + "</span>" +
      '<span class="learn-result-body">' +
      '<span class="learn-result-title">' + esc(item.title) + "</span>" +
      (item.description ? '<span class="learn-result-desc">' + esc(item.description) + "</span>" : "") +
      '<span class="learn-result-meta">' + esc(metaLine(item)) + "</span>" +
      "</span></a>";
  }

  function init(form) {
    var input = form.querySelector("[data-learn-search-input]");
    var suggestBox = form.querySelector("[data-learn-suggestions]");
    var resultsBox = form.querySelector("[data-learn-results]");
    var statusEl = form.querySelector("[data-learn-status]");
    var sortEl = form.querySelector("[data-learn-sort]");
    var filterEls = [].slice.call(form.querySelectorAll("[data-learn-filter]"));
    if (!input) return;

    var indexUrl = form.getAttribute("data-index-url");
    var items = null;         // null = not loaded, [] = loaded but empty
    var loading = false;
    var activeIdx = -1;       // keyboard cursor within the suggestion list
    var suggestions = [];

    function setStatus(msg) { if (statusEl) statusEl.textContent = msg; }

    function load() {
      if (items || loading || !indexUrl) return Promise.resolve();
      loading = true;
      setStatus("Loading search…");
      return fetch(indexUrl, { credentials: "omit" })
        .then(function (r) {
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.json();
        })
        .then(function (data) {
          items = (data && data.items ? data.items : data || []).map(prepare);
          loading = false;
          setStatus("");
          populateTopicFilter();
          run();
        })
        .catch(function (err) {
          loading = false;
          items = [];
          // Honest failure: say search is unavailable rather than showing an
          // empty result list, which reads as "we have nothing on that".
          setStatus("Search is unavailable right now. Browse the topics below instead.");
          if (window.console) console.warn("[learn-search] index failed to load:", err.message);
        });
    }

    // Topics come from the index itself — no second source of truth to drift.
    function populateTopicFilter() {
      var sel = form.querySelector('[data-learn-filter="topic"]');
      if (!sel || sel.dataset.populated === "1" || !items) return;
      var seen = {}, list = [];
      items.forEach(function (i) { if (i.topic && !seen[i.topic]) { seen[i.topic] = 1; list.push(i.topic); } });
      list.sort();
      list.forEach(function (t) {
        var o = document.createElement("option");
        o.value = t;
        o.textContent = t.replace(/-/g, " ").replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        sel.appendChild(o);
      });
      sel.dataset.populated = "1";
    }

    function currentFilters() {
      var f = {};
      filterEls.forEach(function (el) { if (el.value) f[el.getAttribute("data-learn-filter")] = el.value; });
      return f;
    }

    function renderSuggestions(list) {
      suggestions = list;
      activeIdx = -1;
      if (!suggestBox) return;
      if (!list.length) { closeSuggestions(); return; }
      suggestBox.innerHTML = list.map(function (item, i) {
        return '<div class="learn-suggestion" role="option" id="learn-sugg-' + i + '" aria-selected="false" data-idx="' + i + '">' +
          '<span class="learn-suggestion-title">' + esc(item.title) + "</span>" +
          '<span class="learn-suggestion-type">' + esc(TYPE_LABELS[item.type] || item.type) + "</span>" +
          "</div>";
      }).join("");
      suggestBox.hidden = false;
      input.setAttribute("aria-expanded", "true");
    }

    function closeSuggestions() {
      if (!suggestBox) return;
      suggestBox.hidden = true;
      suggestBox.innerHTML = "";
      suggestions = [];
      activeIdx = -1;
      input.setAttribute("aria-expanded", "false");
      input.removeAttribute("aria-activedescendant");
    }

    function moveActive(delta) {
      if (!suggestions.length) return;
      activeIdx = (activeIdx + delta + suggestions.length) % suggestions.length;
      [].slice.call(suggestBox.children).forEach(function (el, i) {
        var on = i === activeIdx;
        el.classList.toggle("is-active", on);
        el.setAttribute("aria-selected", on ? "true" : "false");
        if (on) {
          input.setAttribute("aria-activedescendant", el.id);
          if (el.scrollIntoView) el.scrollIntoView({ block: "nearest" });
        }
      });
    }

    function go(item) { if (item && item.url) window.location.href = item.url; }

    function run() {
      if (!items) return;
      var q = input.value.trim();
      var opts = { filters: currentFilters(), sort: sortEl ? sortEl.value : undefined };
      var all = search(items, q, opts);

      if (resultsBox) {
        resultsBox.innerHTML = all.length
          ? all.slice(0, RESULTS_LIMIT).map(resultHtml).join("")
          : '<p class="learn-empty">Nothing matched' + (q ? ' “' + esc(q) + '”' : "") + ". Try a different word, or clear the filters.</p>";
      }
      // Screen-reader announcement, and the visible count line.
      setStatus(all.length + (all.length === 1 ? " result" : " results") + (q ? ' for “' + q + '”' : ""));

      if (q) renderSuggestions(all.slice(0, SUGGEST_LIMIT));
      else closeSuggestions();
    }

    /* events */

    // Lazy load: the whole point — index is fetched on first focus, not on load.
    input.addEventListener("focus", function () { load(); }, { once: true });

    input.addEventListener("input", function () {
      if (!items) { load(); return; }
      run();
    });

    input.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") { e.preventDefault(); moveActive(1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); moveActive(-1); }
      else if (e.key === "Enter") {
        if (activeIdx >= 0 && suggestions[activeIdx]) { e.preventDefault(); go(suggestions[activeIdx]); }
        else if (indexUrl) { e.preventDefault(); closeSuggestions(); run(); }
      } else if (e.key === "Escape") {
        if (suggestBox && !suggestBox.hidden) { e.preventDefault(); closeSuggestions(); }
        else { input.value = ""; run(); }
      }
    });

    if (suggestBox) {
      suggestBox.addEventListener("mousedown", function (e) {
        // mousedown, not click: blur would close the list before click fires.
        var row = e.target.closest("[data-idx]");
        if (row) { e.preventDefault(); go(suggestions[+row.getAttribute("data-idx")]); }
      });
    }

    filterEls.concat(sortEl ? [sortEl] : []).forEach(function (el) {
      el.addEventListener("change", function () { if (!items) load(); else run(); });
    });

    // No index URL → plain HTML form submit to /search (the Liquid-rendered results page). The
    // loader only takes over when it has something to search locally.
    form.addEventListener("submit", function (e) { if (!indexUrl) return; e.preventDefault(); closeSuggestions(); run(); });

    document.addEventListener("click", function (e) { if (!form.contains(e.target)) closeSuggestions(); });

    // A form pre-filled from ?q= (deep link, or JS-off fallback) loads at once.
    if (input.value.trim()) load();
  }

  function boot() {
    [].slice.call(document.querySelectorAll("[data-learn-search]")).forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  // Exposed for the harness and for any future inline usage. Not a public API.
  window.LearnSearch = { search: search, prepare: prepare, similarity: similarity, tokenise: tokenise };
})();
